<template>
    <div class="talent-pool-list">
        <h3>云队友人才库</h3>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="关键词查询">
                <div style="display: flex;
                flex-direction: row;">
                    <el-select v-model="filter.keywordType" placeholder="关键词类型" clearable
                        @clear="filter.keywordType = 0">
                        <el-option :value="1" label="用户ID"></el-option>
                        <el-option :value="2" label="用户名称"></el-option>
                        <el-option :value="0" label="个人经历"></el-option>
                    </el-select>
                    <el-input placeholder="请输入" v-model="filter.keyword"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="用户手机号">
                <el-input placeholder="用户手机号" v-model="filter.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="最后登录时间">
                <el-date-picker v-model="filter.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="开始时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到">
                <el-date-picker v-model="filter.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="结束时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="注册时间">
                <el-date-picker v-model="filter.regsStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="开始时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到">
                <el-date-picker v-model="filter.regsEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="结束时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="一级类目">
                <el-select v-model="filter.jobCate" clearable @clear="filter.jobCate = null">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="item in firstCates" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="二级类目">
                <el-select v-model="filter.skillTag" clearable @clear="filter.skillTag = null">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="item in secondCates" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="名校毕业">
                <el-select v-model="filter.eliteSchool" placeholder="名校毕业" clearable @clear="filter.eliteSchool = null">
                    <el-option :value="1" label="是"></el-option>
                    <el-option :value="0" label="否"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="名企经验">
                <el-select v-model="filter.famousEnt" placeholder="名企经验" clearable @clear="filter.famousEnt = null">
                    <el-option :value="1" label="是"></el-option>
                    <el-option :value="0" label="否"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="省份">
                <el-select v-model="filter.province" @change="provincechange" clearable @clear="filter.province = null">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="item in province" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="城市">
                <el-select v-model="filter.city" clearable @clear="filter.city = null">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="item in city" :key="item.id" :label="item.name" :value="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="学历">
                <el-select v-model="filter.degree" placeholder="学历" clearable @clear="filter.degree = null">
                    <el-option value="" label="全部"></el-option>
                    <el-option :value="0" label="大专"></el-option>
                    <el-option :value="1" label="本科"></el-option>
                    <el-option :value="2" label="硕士"></el-option>
                    <el-option :value="3" label="博士"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="工作年限">
                <el-select v-model="filter.workYears" placeholder="工作年限" clearable @clear="filter.workYears = null">
                    <el-option :value="1" label="一年以下"></el-option>
                    <el-option :value="2" label="1-3年"></el-option>
                    <el-option :value="3" label="3-5年"></el-option>
                    <el-option :value="4" label="5-10年"></el-option>
                    <el-option :value="5" label="10年以上"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="用户等级">
                <el-select v-model="filter.level" placeholder="用户等级" clearable @clear="filter.level = null">
                    <el-option :value="0" label="Lv0"></el-option>
                    <el-option :value="1" label="Lv1"></el-option>
                    <el-option :value="2" label="Lv2"></el-option>
                    <el-option :value="3" label="Lv3"></el-option>
                    <el-option :value="4" label="Lv4"></el-option>
                    <el-option :value="5" label="Lv5"></el-option>
                    <el-option :value="6" label="Lv6"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button-group>
                    <el-button type="primary" @click="fetch(1)" size="mini">查询</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <div
            style="display: flex;align-items: center;flex-direction: row; justify-content: space-between;margin-top: 12px;margin-bottom: 12px;">
            <div>
                <el-button-group>
                    <el-button type="primary" @click="copyID()" class="copy-id" size="mini">批量复制ID</el-button>
                </el-button-group>
            </div>
            <div class="sortlist">
                <div v-for="(item, index) in sortlist" :key="index" :class="{ selected: selectedIndex === index }"
                    @click="selectItem(index)" style="font-size: 14px; cursor: pointer;">
                    {{ item.title }}
                </div>
            </div>
        </div>
        <el-table @selection-change="handleSelectionChange" :data="list" size="mini" v-loading="loading"
            max-height="550">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column type="index" label="序号">
            </el-table-column>
            <el-table-column prop="userId" label="用户ID">
            </el-table-column>
            <el-table-column prop="nickname" label="用户名称">
            </el-table-column>
            <el-table-column prop="phoneNumber" label="用户手机号" width="150">
            </el-table-column>
            <el-table-column prop="level" label="等级">
            </el-table-column>
            <el-table-column prop="orderNum" label="成单数">
            </el-table-column>
            <el-table-column prop="orderBillingAmount" label="历史累计收入" width="100">
                <template slot-scope="scope">
                    <el-button type="text" @click="goFinal(scope.row)">
                        {{scope.row.orderBillingAmount}}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column prop="activityScore" label="活跃度">
            </el-table-column>
            <el-table-column prop="workCate[0].name" label="一级分类">
            </el-table-column>
            <el-table-column prop="skillTags" label="二级分类">
                <template slot-scope="scope">
                    <div v-for="item in scope.row.skillTags">
                        {{ item.name }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="thirdSkillTags" label="三级分类" width="100">
                <template slot-scope="scope">
                    <div v-for="item in scope.row.thirdSkillTags">
                        {{ item.name }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="jobTitles" label="工作职位" width="100">
                <template slot-scope="scope">
                    <div v-for="item in scope.row.jobTitles">
                        {{ item }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="workYears" label="工作年限">
                <template slot-scope="scope"> {{ getYears(scope.row.workYears) }}</template>
            </el-table-column>
            <el-table-column prop="description" label="工作能力" width="200">
            </el-table-column>
            <el-table-column prop="projectNames" label="项目名称" width="200">
                <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.projectNames">
                        {{ index + 1 }}.{{ item }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="city" label="用户所在城市" width="150">
            </el-table-column>
            <el-table-column prop="registerTime" label="注册时间" width="150">
            </el-table-column>
            <el-table-column prop="lastOnlineTime" label="最后登录时间" width="150">
            </el-table-column>
            <!-- <el-table-column prop="resumeDeg" label="简历完善度">
            </el-table-column> -->
            <el-table-column prop="" label="链接" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" class="copy-btn"
                        :data-clipboard-text="`${frontUrl}/resume/detail/${scope.row.userIdEnc}`"
                        @click="copy">复制链接</el-button>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200" fixed="right">
                <template slot-scope="scope">
                    <el-button-group>
                        <a :href="`/talent-deail/${scope.row.userId}`" target="_blank">查看详情</a>
                    </el-button-group>
                </template>
            </el-table-column>

        </el-table>

        <br />
        <!-- 加载更多按钮 -->
        <div v-if="hasMore" class="load-more" style="display: flex;justify-content: center;">
            <el-button type="primary" @click="loadMore" :loading="loading">
                加载更多
            </el-button>
        </div>
        <!-- 数据加载完成后的提示 -->
        <div v-else class="no-more" style="display: flex;justify-content: center;">
            <span>没有更多数据了</span>
        </div>
        <!-- <div>
            <el-pagination background layout="prev, pager, next" :current-page="pageNum"
                @current-change="(i) => (pageNum = i)" :page-size="limit" :total="total">
            </el-pagination>
        </div> -->

        <el-dialog title="选择不通过原因" :visible.sync="dialog.reject" class="dialog-reject" :close-on-click-modal="false">
            <el-form>
                <el-form-item>
                    <el-select v-model="curData.reviseOpinion" multiple>
                        <el-option v-for="(val, key) in reasons" :key="val.id" :value="val.reason"
                            :label="val.reason"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="updateStatus(curData, 2)">确 定</el-button>
                <el-button @click="toggleDialog('reject')">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { watch } from "vue";
import map from "../../datamap";
import api from "../api";

const { talentPool, workCateList, common } = api;
import Clipboard from "clipboard";

export default {
    name: "services",
    data() {
        return {
            map,
            loading: true,
            sortlist: [
                {
                    title: '默认排序',
                    value: 0
                },
                {
                    title: '活跃度排序',
                    value: 1
                },
                {
                    title: '成单数',
                    value: 2
                },
            ],
            list: [],
            total: 0,
            limit: 20,
            pageNum: 1,
            hasMore: true, // 是否还有更多数据
            total: 0,
            filter: {
                jobCate: null,
                skillTag: null,
                province: null,
                city: null,
                degree: null,
                famousEnt: null,
                eliteSchool: null,
                keywordType: 0,
                keyword: null,
                sort: null,
                startTime: null,
                regsStartTime: null,
                regsEndTime: null,
                endTime: null,
                workYears: null,
                phoneNumber: null,
                level:null
            },
            cates: [],
            dialog: {
                reject: false,
                proposal: false,
            },
            selectedIndex: 0,
            curData: {},
            reasons: [],
            closeReason: [],
            multipleSelection: [],
            city: [],
            province: []
        };
    },
    components: {},
    computed: {
        firstCates() {
            return this.getCatesById(0);
        },
        secondCates() {
            return this.getCatesById(this.filter.jobCate);
        },
    },
    watch: {
        // pageNum() {
        //     this.fetch(2);
        // },

    },
    mounted() {
        this.getAllTags();
        this.fetch();
        this.getProvince()
    },
    methods: {
        loadMore() {
            this.pageNum++;
            this.fetch();
        },
        getYears(Years) {
            let workYears;
            switch (Years) {
                case 1:
                    workYears = "一年以下";
                    break;
                case 2:
                    workYears = "1-3年";
                    break;
                case 3:
                    workYears = "3-5年";
                    break;
                case 4:
                    workYears = "5-10年";
                    break;
                case 5:
                    workYears = "10年以上";
                    break;
            }
            return workYears;
        },
        provincechange(selectedId) {
            const selectedProvince = this.province.find(item => item.id === selectedId);
            console.log(selectedProvince)
            this.filter.province = selectedProvince.name
            this.getCity(selectedProvince.id)
            this.city = []
            this.filter.city = ''; // 重置 city
        },
        selectItem(index) {
            this.selectedIndex = index;
            this.filter.sort = index;
            this.fetch()
        },
        copy() {
            var clipboard = new Clipboard(".copy-btn");
            clipboard.on("success", (e) => {
                this.$message.success("复制成功");
                // 释放内存
                clipboard.destroy();
            });
            clipboard.on("error", (e) => {
                // 不支持复制
                this.$message.error("复制失败，请手动复制收款地址");
                // 释放内存
                clipboard.destroy();
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },


        copyID() {
            const userIds = this.multipleSelection.map(row => row.userId).join('#');
            const clipboard = new Clipboard('.copy-id', {
                text: () => userIds,
            });

            clipboard.on('success', () => {
                this.$message.success('用户ID复制成功！');
                clipboard.destroy();
            });

            clipboard.on('error', () => {
                this.$message.error('复制失败，请重试');
                clipboard.destroy();
            });
        },
        filterTag(value, row) {
            return row.tag === value;
        },
        formatReason(data) {
            let str = "";
            if (data && data.length) {
                data.forEach((item, key) => {
                    str += `${key + 1}、${item}<br>`;
                });
            }
            return str;
        },
        async getProvince() {
            let res = await talentPool.city();
            if (res.data.code == 200) {
                this.province = res.data.data;
            }
        },
        async getCity(newVal) {
            var data = {
                parent_id: newVal
            }
            let res = await talentPool.city(data);
            if (res.data.code == 200) {
                this.city = res.data.data;
            }
        },
        async fetch(num) {
            if (num == 1) {
                this.pageNum = 1;
                this.list = []
            }

            let pageNum = this.pageNum;
            let limit = this.limit;
            this.loading = true;
            let { jobCate, skillTag, showStatus, startTime, endTime, regsStartTime, regsEndTime, degree, eliteSchool,
                famousEnt, sort, keywordType, keyword, province, city, workYears, phoneNumber,level } = this.filter;

            let obj = {
                pageNum: pageNum,
                limit: limit,
                jobCate,
                skillTag,
                showStatus,
                startTime,
                regsStartTime,
                regsEndTime,
                endTime,
                degree,
                eliteSchool,
                famousEnt,
                sort,
                keywordType,
                keyword,
                province,
                city, workYears,
                phoneNumber,
                level
            };
            // 保存当前选中的行的 IDs
            const selectedIds = this.multipleSelection.map(item => item.userId);

            let res = await talentPool.list(obj);
            this.loading = false;
            this.total = res.data.pageinfo.totalCount;
            const newData = res.data.data;

            // 使用 push 合并新数据到原来的 list
            this.list.push(...newData);

            // 在数据更新后，恢复选中的行
            this.$nextTick(() => {
                const table = this.$refs.table;
                if (table) {
                    // 筛选出已选中的行
                    const selectedRows = this.list.filter(item => selectedIds.includes(item.userId));

                    // 手动设置选中的行
                    selectedRows.forEach(row => {
                        table.toggleRowSelection(row, true);
                    });
                }
            });

            // 判断是否还有更多数据
            this.hasMore = this.list.length < this.total;

        },
        async getAllTags() {
            let {
                data: { code, data },
            } = await workCateList.getAllTags();
            if (code == 200) {
                this.cates = data.workCategory;
            }
        },
        getCatesById(id) {
            let arr = [];
            this.cates.forEach((item) => {
                if (item.parentId === id) {
                    arr.push(item);
                }
            });
            return arr;
        },
        toggleDialog(name, data = {}) {

        },
        goFinal(row) {
            this.$router.push({
                path: "/settlement",
                query: {
                userId: row.userId,
                role: 2,
                billStatus: "3",
                },
            });
        },
    },
};
</script>
<style>
.dialog-reject .el-select {
    width: 100%;
}

.selected {
    color: #007aff;
}

.sortlist {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;
}

.sortlist div:nth-child(2) {
    border-left: 1px solid black;
    border-right: 1px solid black;
    padding: 0 12px;
}

.sortlist div {
    padding: 0 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/talent-pool-list.vue